export default __webpack_public_path__ + "images/0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83.png";